// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileUpload_wrapper__2_hcB","dragger":"FileUpload_dragger__5P9AC","image":"FileUpload_image__1s4tn","modal":"FileUpload_modal__3-2y9","tip":"FileUpload_tip__nAX3x"};